export default __webpack_public_path__ + "static/media/macs-gmp1.3d3de9c9.jpg";